import { makeObservable, observable } from 'mobx';
import { UrlManager, UrlTranslator } from '@searchspring/snap-url-manager';

export class tabManager {
	config;
	type;
	custom = {};
	options = [];
	active;
	searchPromises = [];

	constructor(config) {
		if (!config.tabs) return;
		this.config = config;
		this.config.param = this.config.param || 'view';
		this.options = config.tabs
			.filter((tab) => (tab.disabled ? false : true))
			.map((tab) => {
				tab.id = tab.id || tab.controller.id;
				this.type = tab.controller.type;
				tab.lastSearch = '';
				tab.controller.hasSearched = false;

				if (this.type == 'search' && !window.location.href.includes('/collections')) { 
					const searchPromise = tab.controller.search();
					this.searchPromises.push(searchPromise);
					tab.controller.hasSearched = true;
				}

				tab.controller.urlManager = tab.controller.urlManager.withGlobals({ [this.config.param]: [tab.id] });
				tab.controller.store.services.urlManager = tab.controller.urlManager;

				// handle tab selection
				if (tab.controller.type == 'autocomplete') {
					// hidden form inputs for tab selections
					if (!tab.controller.config.action) {
						tab.controller.on('beforeSubmit', async ({ controller, input }, next) => {
							if (input?.form) {
								addHiddenFormInput(input.form, this.config.param, this.active.id);
							}
							await next();
						});
					}
				}

				return tab;
			});
		// Register all search promises
		Promise.all(this.searchPromises).then(() => {
			if (this.config.getDefault && window.location.href.includes('/search')) {
				const defaultTab = this.config.getDefault(this.options);
				this.switch(defaultTab);
			}
		});
		// set active based on starting url param
		const urlManager = new UrlManager(new UrlTranslator());
		const startingTab = config.default || this.options[0].id;

		if (this.type == 'search') {
			// functionality for back/forward browser buttons
			urlManager.subscribe((prev, next) => {
				const nextTab = (next.view && next.view.length && next.view[next.view.length - 1]) || startingTab;
				this.active = this.get(nextTab);
		});

			//Set articles to show if url is blog
			if(window.location.href.includes('/blog')) {
        this.active = this.get('articles')
			} else {
				this.active = this.get(startingTab);
				if (!this.active.controller.hasSearched) {
					this.active.controller.search();
					this.active.controller.hasSearched = true;
				}
			}
		} else if (this.type === 'autocomplete') {
			this.switch(startingTab);
		}

		// initialize non selected controllers
		this.options.forEach((tab) => {
			if (tab.id != startingTab) {
				tab.controller.init();
			}
		});

		makeObservable(this, {
			custom: observable,
			options: observable,
			active: observable,
		});
	}

	get(id) {
		return this.options?.filter((tab) => tab.id == id)[0];
	}

	switch = (id) => {
		const tab = this.get(id);

		if (tab && (tab?.id != this.active?.id || !this.active)) {
			if (this.type == 'search') {
				const query = this.active?.controller.urlManager.state.query || tab.controller.urlManager.state.query;
				tab.controller.urlManager.set(this.config.param, [tab.id]).remove('page').go();
				tab.controller.search();
			} else if (tab.controller.type == 'autocomplete') {
				this.active?.controller.unbind();
				tab.controller.bind();

				const inputElement = this.active?.controller.store.state.focusedInput;
				tab.controller.setFocused(inputElement);
			}

			this.active = tab;
		}
	};
}

function addHiddenFormInput(form, name, value) {
	const inputElem = document.createElement('input');
	inputElem.type = 'hidden';
	inputElem.name = name;
	inputElem.value = value;
	const existingElem = form.querySelector(`[name="${name}"]`);
	if (!existingElem) {
		form.append(inputElem);
	}
}